module.exports = __webpack_public_path__ + "img/2398@2x.ac2b03d1.png";